webpackJsonp([1],{

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__ = __webpack_require__(228);






// axios 配置
//let hostUrl = 'http://192.168.123.113:8568/';//薛嘉淇
//let hostUrl = 'http://192.168.123.93:8568/';//宋居光
//let hostUrl = 'http://192.168.123.96:8568/';//汪志
//let hostUrl = 'http://192.168.123.101:8568/';//孙强
//let hostUrl = 'http://192.168.123.101:8568/';//丁涛
//let hostUrl = 'http://15w07q0502.51mypc.cn:37796/';//孙强
//let hostUrl = 'http://192.168.123.106:8568/';//朱亚军
//let hostUrl = 'http://47.98.174.100:8999/';// https开发
//let hostUrl = 'http://116.62.62.201:8568/';//临时
//let hostUrl = 'https://test04.sso.jia-r.com/';//开发新
// let hostUrl = 'https://test03.sso.yun-r.com/';//https测试测试新
// let hostUrl = 'https://develop.sso.yun-r.com';//临时环境
// let hostUrl = 'https://test01.sso.yun-r.com';//临时环境
var hostUrl = 'https://test02.sso.yun-r.com'; //临时环境
// let hostUrl = 'https://cluster.sso.yun-r.com';//临时环境
// let hostUrl = 'https://sso.yun-r.com';//正式新
//timeout: 60000;
//headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'}
//headers:{'content-type': 'application/json;charset=UTF-8'}
var instance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: hostUrl
});
function fetch(url, param) {
  var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10000;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var userParam = {
      myUserName: window.sessionStorage.getItem('myUserName'),
      token: window.sessionStorage.getItem('token')
    };
    var params = void 0;
    var contentType = "application/x-www-form-urlencoded;charset=UTF-8";
    if (formData) {
      //如果有文件流需要formData格式，分开传参json格式的param和文件格式的formData，其他接口默认formData为false
      //form表单所需contentType
      contentType = 'multipart/form-data';
    }
    //验签value加密处理
    var valueStr = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].jsonSort(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(userParam, param));
    var createTime = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].formatDate.format(new Date(), 'yyyyMMddhhmmss');
    var key = "ITL87v5ik7*=()55ilpp751O";
    var sign = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].getmd5(valueStr + createTime + key);
    // console.log(sign)
    //AES加密
    var pubkey = "5278MMN5412365UH";
    var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(userParam, param, { "createTime": createTime, "sign": sign });
    console.log(data);
    var ciphertext = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].encryptByAES(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data), pubkey);
    if (formData) {
      formData.append("encryptScript", ciphertext);
      params = formData;
    } else {
      params = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ encryptScript: ciphertext }));
    }
    var config = {
      headers: { 'Content-Type': contentType },
      timeout: timeout
    };
    instance.post(url, params, config).then(function (response) {
      var encryptScript = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].decryptByAES(response.data.encryptScript, pubkey);
      if (JSON.parse(encryptScript).allData) {
        console.log(url);
        console.log(JSON.parse(JSON.parse(encryptScript).allData));
        var resSign = __WEBPACK_IMPORTED_MODULE_5__scripts_common_util__["a" /* default */].getmd5(JSON.parse(encryptScript).allData + JSON.parse(encryptScript).createTime + key);
        if (resSign == JSON.parse(encryptScript).sign) {
          //验签
          resolve(JSON.parse(JSON.parse(encryptScript).allData));
        } else {
          resolve(JSON.parse('{"msgCode":"SmsgCode","msg":"验签失败"}'));
        }
      } else {
        resolve(JSON.parse(encryptScript));
      }
    }, function (err) {
      reject(err);
    }).catch(function (error) {
      reject(error);
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 用户登录
   */
  login: function login(params) {
    return fetch('sso/login', params);
  },

  /**
   * 判断是否需要登录
   */
  checkLogin: function checkLogin(params) {
    return fetch('sso/checkLogin', params);
  },

  /**
   * 获取请求地址
   */
  getHost: function getHost() {
    return hostUrl;
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
var Emoji_Reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;

//md5加密

//AES



function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    data: {
        // 本地跳转路径
        // baseURL:'http://192.168.123.106:8087/',//朱亚军
        // baseURL:'http://192.168.123.93:8568/',//宋居光
        // baseURL:'http://192.168.123.101:8089/',//丁涛
        // baseURL:'https://cluster.sso.jia-r.com/',//开发新'
        // baseURL:'https://test04.sso.jia-r.com/',//https测试测试新
        // baseURL:'https://develop.sso.yun-r.com/',//正式新
        // baseURL:'https://test01.sso.yun-r.com/',//正式新
        // baseURL:'https://sso.yun-r.com/',//正式新
        baseURL: 'https://test02.sso.yun-r.com/' //正式新
        // baseURL:'https://cluster.sso.yun-r.com/',//正式新
        // baseURL:'https://hw.sso.jia-r.com/',//华为云环境
    },
    // 系统类型
    // systemType:'cluster',//临时
    // systemType:'develop',//测试
    // systemType:'test01',//测试
    systemType: 'test02', //测试
    // systemType:'test03',//测试
    // systemType:'real',//正式

    //检测请求码
    checkCode: function checkCode(obj, res) {
        var _this = this;

        if (res.msgCode == 0) {
            return true;
        }
        if (res.msgCode == 2998) {
            // obj.$alert("登录过期，请重新登录", '提示', {
            //     confirmButtonText: '确定',
            //     type: 'warning',
            //     callback: () => {
            //         window.location.href = '/login';
            //     }
            // });
            window.location.href = '/login';
        } else if (res.msgCode == 2993) {
            obj.$alert("您的账号已在其他设备登录，如非本人操作，请重新登录修改密码", '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                callback: function callback(action) {
                    window.location.href = '/login';
                }
            });
        } else if (res.msgCode == 2992) {
            window.location.href = '/login';
        } else if (res.msgCode == 3004) {
            obj.$alert("账号/密码输入错误，您的登录剩余有效次数为" + res.data.errorCount + "次。", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
        } else if (res.msgCode == 3015) {
            obj.$alert("登录失败，账号/密码输入错误次数过多，请" + res.data.remainTime + "分钟后重新登录。", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
        } else if (res.msgCode == "SmsgCode") {
            obj.$alert(res.msg, '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                callback: function callback(action) {
                    _this.$api.logout().then(function (res) {
                        if (_this.$util.checkCode(_this, res)) {}
                    }).catch(function (err) {
                        _this.$util.showCatchErr(_this, err, '退出登录失败'); // 从数据库获取数据出现问题
                    });
                    window.location.href = '/login';
                }
            });
        } else if (res.msgCode == 5000) {
            //验证码来源有误，强制刷新
            window.location.reload();
        } else if (res.msgCode == 6000) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Message"])({
                message: "验证码填写错误",
                type: "error"
            });
        } else {
            setTimeout(function () {
                obj.$alert(res.msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                });
            }, 300);
        }
        return false;
    },

    //请求失败
    showCatchErr: function showCatchErr(obj, err, msg) {
        var isImport = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var errorMsg = "请求服务器失败，请稍后重试";
        /*if(err.toString().indexOf("Error: Request failed with status code")!=-1){
          errorMsg="请求服务器失败，状态码为"+err.toString().substring(err.toString().lastIndexOf(" "),err.toString().length);
        }*/
        if (err.toString().indexOf("timeout") != -1) {
            errorMsg = "请求服务器超时";
        }
        if (err.toString() == "Error: Network Error") {
            errorMsg = isImport ? "原因一：文件可能已被移至别处或遭到删除，原因二：网络错误，请稍后重试" : "服务器失联，请稍后重试";
        }
        console.log(err);
        if (err.toString().indexOf("TypeError") != -1) {
            //前端代码异常或后台返回
            errorMsg = "页面数据异常";
        }
        obj.$alert(msg ? msg + "，" + errorMsg : errorMsg, '提示', {
            confirmButtonText: '确定',
            type: 'warning'
        });
        return false;
    },
    checkProductType: function checkProductType(rule, value, callback) {
        var reg = /^[A-Za-z0-9\-]+$/ig;
        if (!reg.test(value)) {
            callback(new Error('设备型号由数字、字母、符号"-"组成'));
        } else {
            callback();
        }
    },
    checkEmojiNotNull: function checkEmojiNotNull(msg) {
        var emojiNotNull = function emojiNotNull(rule, value, callback) {
            if (!value) {
                callback(new Error(msg));
            } else if (value.match(Emoji_Reg)) {
                callback(new Error('不支持表情符号'));
            } else {
                callback();
            }
        };
        return emojiNotNull;
    },

    //判断是否包含表情符号
    checkEmoji: function checkEmoji(rule, value, callback) {
        if (!value) {
            return callback();
        }
        if (value.match(Emoji_Reg)) {
            callback(new Error('不支持表情符号'));
        } else {
            callback();
        }
    },
    checkEmojiIF: function checkEmojiIF(value) {
        if (value.match(Emoji_Reg)) {
            return false;
        } else {
            return true;
        }
    },

    //去空格及换行----添加修改输入框
    checkBlank: function checkBlank(rule, value, callback) {
        if (value) {
            value = value.replace(/^\s+|\s+$/g, '');
            if (!value) {
                callback(new Error('请输入有效字符'));
            } else if (value.match(Emoji_Reg)) {
                callback(new Error('不支持表情符号'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测手机号
    checkPhoneNum: function checkPhoneNum(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^1[3|4|5|6|7|8|9]\\d{9}$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测手机号,必填
    checkPhoneNumNotNull: function checkPhoneNumNotNull(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^1[3|4|5|6|7|8|9]\\d{9}$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号码'));
            } else {
                callback();
            }
        } else {
            callback(new Error('请输入手机号码'));
        }
    },

    //检测手机号或座机号 非必填
    checkAllPhoneNum: function checkAllPhoneNum(rule, value, callback) {
        if (value) {
            var regstr = "";
            if (value.toString().substring(0, 1) == "1") {
                //修改住户的时候传递过来的value为number类型
                regstr = "^1[3|4|5|6|7|8|9]\\d{9}$";
            } else {
                regstr = "^(\(0\\d{2,3}\)|0\\d{2,3}-)\\d{7,8}$";
            }
            var reg = new RegExp(regstr, "ig");

            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号或座机号'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测是否为整数--回调方法
    checkInteger: function checkInteger(rule, value, callback) {
        if (value) {
            var reg = new RegExp("^[0-9]*$", "ig");
            if (!reg.test(value)) {
                callback(new Error('请输入纯数字'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    // //检测是否为整数--公共方法
    checkInt: function checkInt(obj, value, hint) {
        var reg = new RegExp("^[0-9]*$", "ig");
        if (!value) {
            return;
        }
        if (!reg.test(value)) {
            obj.$alert(hint, '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            return false;
        }
        return true;
    },

    //检测是否为ip或域名 回调形式
    checkIP: function checkIP(rule, value, callback) {
        if (value) {
            /* var regIpStrAll = '([hH][tT]{2}[pP]:\\/\\/|[hH][tT]{2}[pP][sS]:\\/\\/)((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';*/
            var regIpStr = '((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';
            var regDomainStr = '[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?';
            var regIp = new RegExp(regIpStr, "ig");
            var regDomain = new RegExp(regDomainStr, "ig");
            if (!regIp.test(value) && !regDomain.test(value)) {
                callback(new Error('请输入正确格式的通讯地址'));
            } else {
                callback();
            }
        } else {
            callback();
        }
    },

    //检测是否为ip或域名--公共方法 IP地址、前后有汉字、带参数的，都是OK的。
    checkIPAddress: function checkIPAddress(obj, value) {
        if (!value) {
            return;
        }
        var regIpStr = '((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)(\\.((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]\\d)|\\d)){3}';
        var regDomainStr = '[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?';
        var regIp = new RegExp(regIpStr, "ig");
        var regDomain = new RegExp(regDomainStr, "ig");
        if (!regIp.test(value) && !regDomain.test(value)) {
            obj.$alert("请输入正确格式的链接地址", '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            });
            return false;
        }
        return true;
    },

    //必填，人员账号检测只能数字和字母
    checkNumABC: function checkNumABC(rule, value, callback) {
        var errorMsg = "请输入以字母开头，长度在5~30之间，包含字母、数字格式的账号";
        if (!value) {
            return callback(new Error(errorMsg));
        }
        var reg = new RegExp("^[a-zA-Z][a-zA-Z0-9]{4,29}$", "ig");
        if (!reg.test(value)) {
            return callback(new Error(errorMsg));
        }
        callback();
    },
    checkAddRedix: function checkAddRedix(rule, value, callback) {
        var errorMsg = "不能包含小数点";
        if (value.toString().indexOf('.') > -1) {
            return callback(new Error(errorMsg));
        }
        callback();
    },
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },

    formatDate: {
        //时间戳转时间
        formatStampsToTime: function formatStampsToTime(inputTime) {
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        formatget00: function formatget00(inputTime) {
            //用于商务收费 修改时间 起始时间重置为 00:00:00 格式
            var date = new Date(inputTime);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + '0' : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            console.log(y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second);
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },

        //时间格式
        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },

        //变成yyyy-MM-dd格式
        formatnoSecdDate: function formatnoSecdDate(time) {
            if (!time) {
                return;
            }
            // return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
            //    console.log(this.format(new Date(time), 'yyyy-MM-dd'))
            return this.format(new Date(time), 'yyyy-MM-dd');
        },

        //变成yyyy-MM-dd hh:mm:ss格式
        formatToRequiredDate: function formatToRequiredDate(time) {
            if (!time) {
                return;
            }
            // return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
            return this.format(new Date(time), 'yyyy-MM-dd hh:mm:ss');
        },

        //将时间的时分秒变成23：59：59
        formatToMaxDate: function formatToMaxDate(obj, time) {
            if (!time) {
                return;
            }
            time.setHours(23, 59, 59);
            return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        },

        //将时间的时分秒变成23：59：59
        formatToMaxDateanther: function formatToMaxDateanther(obj, time) {
            if (!time) {
                return;
            }
            // time.setHours(23, 59, 59);
            return obj.$moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
        },
        compareSearchTime: function compareSearchTime(obj, begin, end) {
            if (!begin || !end) {
                return true;
            }
            var startTime = this.formatToRequiredDate(begin);
            var endTime = this.formatToMaxDate(obj, end);
            if (startTime >= endTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '开始时间应小于结束时间！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        compareTime: function compareTime(obj, begin, end) {
            var startTime = this.format(new Date(begin), 'yyyy-MM-dd hh:mm:ss');
            var endTime = this.format(new Date(end), 'yyyy-MM-dd hh:mm:ss');
            // console.log(startTime,endTime)
            if (startTime >= endTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '开始时间应小于结束时间！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        newCurTime: function newCurTime(obj, begin, end) {
            var startTime = this.formatnoSecdDate(begin);
            var endTime = this.format(new Date(end), 'yyyy-MM-dd hh:mm:ss');
            // console.log(startTime,endTime)
            if (endTime < startTime) {
                //window.alert("开始日期时间应小于结束日期时间");
                obj.$message({
                    message: '当前起始日期不能小于之前起始日期！',
                    type: 'warning'
                });
                return false;
            };
            return true;
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);
                            break;
                        case 'M':
                            _date.setMonth(_int - 1);
                            break;
                        case 'd':
                            _date.setDate(_int);
                            break;
                        case 'h':
                            _date.setHours(_int);
                            break;
                        case 'm':
                            _date.setMinutes(_int);
                            break;
                        case 's':
                            _date.setSeconds(_int);
                            break;
                    }
                }
                return _date;
            }
            return null;
        },

        //指定年月的该月份的天数
        monthDay: function monthDay(year, month) {
            month = parseInt(month, 10);
            var d = new Date(year, month, 0); //这个是都可以兼容的
            var date = new Date(year + "/" + month + "/0"); //IE浏览器可以获取天数，谷歌浏览器会返回NaN
            return d.getDate();
        },

        getNextMonth: function getNextMonth(date, length) {
            var yy = date.getFullYear();
            var mm = date.getMonth();
            var dd = date.getDate();

            var nm = 0; //目标月份
            nm = mm + length;
            var nd = 0; //目标天数

            if (this.monthDay(yy, nm + 1) < dd) {
                nd = this.monthDay(yy, nm + 1);
            } else {
                console.log(dd);
                nd = dd;
            }

            date.setDate(1);
            date.setMonth(nm);
            date.setDate(nd);
            return date;
        },
        //获取当月最大天数
        mGetDate: function mGetDate(year, month) {
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        getNextDay: function getNextDay(date, length) {
            var yy = date.getFullYear();
            var mm = date.getMonth();
            var dd = date.getDate();
            var dm = 0; //目标天数
            dm = dd + length;
            var ds = 0;
            var ms = 0; //目标月份
            if (dm > this.mGetDate(yy, mm)) {
                ms = mm + 1;
                ds = dm - this.mGetDate(yy, mm);
            } else {
                ms = mm;
                ds = dm;
            }
            date.setDate(1);
            date.setMonth(ms);
            date.setDate(ds);
            return date;
        },
        getNexYear: function getNexYear(date, length) {
            var yy = date.getFullYear();
            var mm = date.getMonth();
            var dd = date.getDate();
            date.setDate(1);
            date.setMonth(mm);
            date.setFullYear(yy + length);
            date.setDate(dd);
            return date;
        }

    },

    //计算base64字节流的大小
    getBase64FileSize: function getBase64FileSize(data) {
        var str = data.substring(22); //1.去掉头部的data:image/png;base64,（注意有逗号）
        if (str.indexOf('=') > 0) {
            str = str.substring(0, str.indexOf('=')); //去掉等号
        }
        var strLength = str.length; //原来的字符流大小，单位为字节
        return parseInt(strLength - strLength / 8 * 2); //计算后得到的文件流大小，单位为字节
    },


    //分页跳转
    handleJumpInput: function handleJumpInput(jumpTo) {
        if (!/^\d+$/.test(jumpTo)) {
            jumpTo = '';
        }
        return jumpTo;
    },
    handleJump: function handleJump(jumpTo, pageCount) {
        if (jumpTo == '') {
            return jumpTo;
        }
        if (jumpTo > pageCount) {
            jumpTo = pageCount;
        }
        if (jumpTo < 1) {
            jumpTo = '1';
        }
        return jumpTo;
    },
    getmd5: function getmd5(value) {
        var md5 = __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash("md5");
        md5.update(value);
        var a = md5.digest('hex');
        return a;
    },

    //处理json值拼接
    jsonSort: function jsonSort(jsonObj) {
        var arr = [];
        var newJson = {};
        for (var key in jsonObj) {
            newJson[key.toLowerCase()] = jsonObj[key];
            arr.push(key.toLowerCase());
        }
        arr.sort();
        var str = '';
        for (var i in arr) {
            if (newJson[arr[i]] == undefined || newJson[arr[i]] == null) {
                newJson[arr[i]] = '';
            }
            str += newJson[arr[i]];
        }
        return str;
    },

    // 解密
    decryptByAES: function decryptByAES(message, key) {
        var decrypt = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.decrypt(message, __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(key), { mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.ECB, padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7 });

        var decryptedStr = decrypt.toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8);
        return decryptedStr.toString();
    },

    // 加密
    encryptByAES: function encryptByAES(message, key) {
        var encrypted = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.encrypt(message, __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(key), {
            mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.ECB,
            padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
        });
        return encrypted.toString();
    },
    htmlEncode: function htmlEncode(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&/g, "&amp;");
        s = s.replace(/</g, "&lt;");
        s = s.replace(/>/g, "&gt;");
        s = s.replace(/ /g, "&nbsp;");
        s = s.replace(/\'/g, "&#39;");
        s = s.replace(/\"/g, "&quot;");

        return s;
    },
    htmlDecode: function htmlDecode(str) {
        var s = "";
        if (str.length == 0) return "";
        s = str.replace(/&amp;/g, "&");
        s = s.replace(/&lt;/g, "<");
        s = s.replace(/&gt;/g, ">");
        s = s.replace(/&nbsp;/g, " ");
        s = s.replace(/&#39;/g, "\'");
        s = s.replace(/&quot;/g, "\"");
        return s;
    },
    xss: function xss(str) {
        if (str.length == 0) return "";
        str = str.replace(/&nbsp;/ig, ''); // 去掉&nbsp;
        str = str.replace(/alert/gi, ''); // 去掉alert;
        str = str.replace(/%3CSCRIPT/gi, ''); // 去掉3CSCRIPT;
        str = str.replace(/input/ig, ''); // 去掉input;
        str = str.replace(/iframe/ig, ''); // 去掉iframe;
        str = str.replace(/window/ig, ''); // 去掉window;
        str = str.replace(/link/ig, ''); // 去掉link;
        str = str.replace(/location/ig, ''); // 去掉location;
        str = str.replace(/JAVASCRIPT/ig, ''); // 去掉JAVASCRIPT;
        str = str.replace(/update/ig, ''); // 去掉update;
        str = str.replace(/insert/ig, ''); // 去掉insert;
        str = str.replace(/select/ig, ''); // 去掉select;
        str = str.replace(/script/ig, ''); // 去掉select;
        return str;
    },

    //将数字（整数）转为汉字，从零到一亿亿，需要小数的可自行截取小数点后面的数字直接替换对应arr1的读法就行了
    convertToChinaNum: function convertToChinaNum(num) {
        var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
        var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'); //可继续追加更高位转换值
        if (!num || isNaN(num)) {
            return "零";
        }
        var english = num.toString().split("");
        var result = "";
        for (var i = 0; i < english.length; i++) {
            var des_i = english.length - 1 - i; //倒序排列设值
            result = arr2[i] + result;
            var arr1_index = english[des_i];
            result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
        //将【亿万】换成【亿】
        result = result.replace(/亿万/g, '亿');
        //移除末尾的零
        result = result.replace(/零+$/, '');
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        return result;
    },

    // cookie存储
    setCookie: function setCookie(name, value, iDay) {
        __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.set(name, value, "0", null, ".yun-r.com"); //线上
        // VueCookies.set(name,value,"0");//本地
    }
});

/*export function setCookie(name, value, iDay) {
    let oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + oDate;
}

export function getCookie(name) {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return decodeURIComponent(arr[2]);
    else
        return '';
}

export function removeCookie(name) {
    //setCookie(name, '1', -1);
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export function clearAllCookie() {
    removeCookie("token");
    removeCookie("roleName");
    removeCookie("myUserName");

    /!*
    //清除所有的cookie 不合理
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
     if (keys) {
         for (let i = keys.length; i--;)
             document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
     }*!/
}*/

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 238:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vuex_store__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fetch_api__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scripts_common_util__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);

/**
 * 驼峰转 - 分割
 * eg: cameCase('TransferDom') => 'transfer-dom'
 * @param key
 * @returns {string}
 */
/*const cameCase = (key) => {
    return key.replace(/([A-Z])/g, (a, b) => '-' + b.toLowerCase()).replace(/^-/, '')
}

// 注册全局指令
Object.keys(directives).map(key => {
    // 这里的Key是TransferDom，转换后为transfer-dom
    // 注册指令时为transfer-dom，使用时要加前缀v。eg： v-transfer-dom 不是会自动转分割吗？
    Vue.directive(cameCase(key), directives[key])
})*/

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_9__fetch_api__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$util = __WEBPACK_IMPORTED_MODULE_10__scripts_common_util__["a" /* default */];
//时间 8个时区问题

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_11_moment___default.a;

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    router: __WEBPACK_IMPORTED_MODULE_8__routes__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_6__vuex_store__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
    }
}).$mount('#app');

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {}
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import MenuUtils from '@/scripts/common/MenuUtils'


var routers = [];
/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loginLoading: false,
            loginForm: {
                account: '',
                password: '',
                verificationCode: ''
            },
            codedata: '',
            loginFormRules: {
                account: [{ required: true, validator: this.$util.checkEmojiNotNull('请输入账号'), trigger: 'blur' }],
                password: [{ required: true, validator: this.$util.checkEmojiNotNull('请输入密码'), trigger: 'blur' }],
                verificationCode: [{ required: true, validator: this.$util.checkEmojiNotNull('请输入验证码'), trigger: 'blur' }]
            },
            isLogin: true,
            backURL: '',
            sessionId: '',
            secondarySessionId: '',
            type: 1,
            imgUrl: '',
            imgFlag: true
        };
    },
    mounted: function mounted() {
        if (this.$route.query.backURL == undefined) {
            this.backURL = '';
        } else {
            this.backURL = window.atob(this.$route.query.backURL);
            this.type = this.$route.query.type;
            console.log(this.backURL);
            if (!__WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.get(this.$util.systemType + 'sessionId')) {
                this.$util.setCookie(this.$util.systemType + "sessionId", this.guid());
            }
            this.sessionId = __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.get(this.$util.systemType + 'sessionId');

            //是否需要登录
            this.checkLogin();
        }
    },

    methods: {
        guid: function guid() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });
        },

        // 系统跳转方法
        goSystem: function goSystem(type) {
            //线上
            var reg = new RegExp('sso', 'g');
            if (type == 1) {
                this.backURL = '' + window.location.href.replace(reg, 'operate');
                this.$util.setCookie(this.$util.systemType + 'operateSession', this.guid());
            } else {
                this.backURL = '' + window.location.href.replace(reg, 'assess');
                this.$util.setCookie(this.$util.systemType + 'assessSession', this.guid());
            }
            window.location.href = this.$util.data.baseURL + 'login?backURL=' + window.btoa(this.backURL) + '&type=' + type;

            // 本地
            // let reg=new RegExp('8568','g') 
            // if(type==1){
            //     // this.backURL=''+window.location.href.replace(reg,'80');
            //     this.backURL=''+window.location.href.replace(reg,'8087');
            //     this.$util.setCookie(this.$util.systemType+"operateSession",this.guid())
            // }else{
            //     this.backURL=''+window.location.href.replace(reg,'8086');
            //     this.$util.setCookie(this.$util.systemType+"assessSession",this.guid())
            // }
            // window.location.href=window.location.href+'?backURL='+window.btoa(this.backURL)+'&type='+type
        },
        checkLogin: function checkLogin() {
            var _this = this;

            var data = {
                mainSessionId: this.sessionId,
                secondarySessionId: this.type == 1 ? __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.get(this.$util.systemType + 'operateSession') : __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.get(this.$util.systemType + 'assessSession'),
                type: this.type
            };
            this.$api.checkLogin(data).then(function (res) {
                if (_this.$util.checkCode(_this, res)) {
                    if (res.data) {
                        var info = {
                            'token': res.data.token,
                            'roleName': res.data.roleName,
                            'myUserName': res.data.myUserName,
                            'realName': res.data.realName

                        };
                        if (_this.type == 1) {
                            _this.$util.setCookie(_this.$util.systemType + 'operateInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
                        } else {
                            _this.$util.setCookie(_this.$util.systemType + 'assessInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
                        }
                        //获取到有token直接跳转对应系统
                        window.location.href = _this.backURL;
                    } else {
                        _this.isLogin = false;
                        //无token则走登录流程
                        _this.getVerificationCode();
                    }
                }
            }).catch(function (err) {
                _this.getVerificationCode(); //更新验证码
                _this.$util.showCatchErr(_this, err, '检测是否登录获取失败'); // 从数据库获取数据出现问题
            });
        },
        getVerificationCode: function getVerificationCode() {
            var _this2 = this;

            // var $chars = 'ABCDEFGHJKMNPQRSTWXYZgabcdefhijkmnprstwxyz1234567890';
            // var maxPos = $chars.length;
            // var code = '';
            // for (var i = 0; i < 4; i++) {
            //     code += $chars.charAt(Math.floor(Math.random() * maxPos));
            // }
            // this.codedata = code;
            this.imgUrl = false;
            this.$nextTick(function () {
                _this2.imgUrl = true;
                var host = _this2.$api.getHost();
                if (_this2.type == 1) {
                    _this2.imgUrl = host.split(':')[1] + '/sso/captcha/render?validCodeSource=operate&d=' + new Date().getTime();
                } else {
                    _this2.imgUrl = host.split(':')[1] + '/sso/captcha/render?validCodeSource=price&d=' + new Date().getTime();
                }
            });
        },
        handleLogin: function handleLogin() {
            var _this3 = this;

            if (this.loginLoading) {
                return false;
            }
            this.loginLoading = true;
            this.$refs.loginForm.validate(function (valid) {
                if (!valid) {
                    _this3.loginLoading = false;
                    return false;
                }
                // if (this.codedata.toLowerCase() != this.loginForm.verificationCode.toLowerCase()) {
                //     this.$message({
                //         message: "验证码填写错误",
                //         type: 'error'
                //     });
                //     this.loginLoading = false;
                //     this.getVerificationCode();//更新验证码
                //     return false;
                // }
                var loginParams = {
                    mainSessionId: _this3.sessionId,
                    secondarySessionId: _this3.type == 1 ? __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.get(_this3.$util.systemType + 'operateSession') : __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default.a.get(_this3.$util.systemType + 'assessSession'),
                    type: _this3.type,
                    userName: _this3.loginForm.account,
                    password: _this3.encryptByDES(_this3.loginForm.password, 'UU895L85214UUY54199633RRT74166BE'),
                    validCode: _this3.loginForm.verificationCode,
                    validCodeSource: _this3.type == 1 ? 'operate' : 'price'
                };
                _this3.$api.login(loginParams).then(function (res) {
                    if (_this3.$util.checkCode(_this3, res)) {
                        _this3.loginLoading = false;
                        var info = {
                            'token': res.data.token,
                            'roleName': res.data.roleName,
                            'myUserName': res.data.myUserName,
                            'realName': res.data.realName,
                            'account': _this3.loginForm.account,
                            'loginpd': _this3.encryptByDES(_this3.loginForm.password, 'UU895L85214UUY54199633RRT74166BE'),
                            'passwordTime': res.data.passwordTime
                        };
                        if (_this3.type == 1) {
                            _this3.$util.setCookie(_this3.$util.systemType + 'operateInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
                        } else {
                            _this3.$util.setCookie(_this3.$util.systemType + 'assessInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(info));
                        }
                        //登录成功后
                        window.location.href = _this3.backURL;
                    } else {
                        _this3.loginLoading = false;
                        _this3.getVerificationCode(); //更新验证码
                    }
                }).catch(function (err) {
                    _this3.loginLoading = false;
                    _this3.getVerificationCode(); //更新验证码
                    _this3.$util.showCatchErr(_this3, err, '登录失败'); // 从数据库获取数据出现问题
                });
            });
        },
        encryptByDES: function encryptByDES(message, key) {
            var keyHex = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(key);
            var encrypted = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.DES.encrypt(message, keyHex, {
                mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.ECB,
                padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
            });
            return encrypted.toString();
        }
    }
});

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetch_api__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login_vue__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//
var routes = [{
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Login_vue___default.a,
    name: '',
    hidden: true
}];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: routes
    /*: [
        { path: '*', component: notFound }
    ]*/
});

// import MenuUtils from '@/scripts/common/MenuUtils'


router.beforeEach(function (to, from, next) {
    /* var explorer = window.navigator.userAgent.toLowerCase() ;
     //ie
     if (explorer.indexOf("msie") >= 0) {
         let ver = explorer.match(/msie ([\d.]+)/)[1];
         let hint = '您的ie浏览器当前版本过低，请升级到ie10及以上'
         if(ver < 10){
             alert(hint);
         }
         return false;
     }*/

    if (to.path == '/') {
        window.location.href = '/login';
        return false;
    }
    if (to.path == '/login') {
        sessionStorage.clear();
        next();
        return false;
    }
    if (to.path === '/login') {
        //这里不使用router进行跳转，是因为，跳转到登录页面的时候，是需要重新登录，获取数据的，这个时候，会再次向router实例里面add路由规则，
        //而next()跳转过去之后，没有刷新页面，之前的规则还是存在的，但是使用location的话，可以刷新页面，当刷新页面的时候，整个app会重新加载
        //而我们在刷新之前已经把sessionStorage里的user移除了，所以上面的添加路由也不行执行
        window.sessionStorage.removeItem('menuInfo');
        window.sessionStorage.removeItem('isLoadNodes');
        window.location.href = '/login';
        return false;
    }
    if (to.path != '/login') {
        window.location.href = '/login';
    } else {
        if (to.path) {
            // axios.get('../static/version.json?_=' + Math.random()).then(response => {
            //     if (200 == response.status) {
            //         if (typeof (response.data.version)!='undefined'&&process.env.VERSION !== response.data.version) {
            //             window.location.reload(true);
            //             return;
            //         }
            //         next();
            //     }
            // }).catch(err => {
            //     next();
            // });
            next();
            if (to.path == '/main') {
                history.pushState(null, null, document.URL);
            }
        } else {
            next({ path: '/404' });
        }
    }
});
router.afterEach(function (to, from, next) {
    document.title = '云半径';
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increment", function() { return increment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrement", function() { return decrement; });
//test
var increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCount", function() { return getCount; });
//test
var getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(536);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// 应用初始状态
var state = {
    count: 10

    // 定义所需的 mutations
};var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

// 创建 store 实例
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    state: state,
    mutations: mutations
}));

/***/ }),

/***/ 836:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.5.3","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.5.3","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.5.3","saveSpec":null,"fetchSpec":"^6.5.3"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmmirror.com/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@^6.5.3","_where":"G:\\project\\itlong-cloud-sso\\node_modules\\browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 330,
	"./af.js": 330,
	"./ar": 337,
	"./ar-dz": 331,
	"./ar-dz.js": 331,
	"./ar-kw": 332,
	"./ar-kw.js": 332,
	"./ar-ly": 333,
	"./ar-ly.js": 333,
	"./ar-ma": 334,
	"./ar-ma.js": 334,
	"./ar-sa": 335,
	"./ar-sa.js": 335,
	"./ar-tn": 336,
	"./ar-tn.js": 336,
	"./ar.js": 337,
	"./az": 338,
	"./az.js": 338,
	"./be": 339,
	"./be.js": 339,
	"./bg": 340,
	"./bg.js": 340,
	"./bm": 341,
	"./bm.js": 341,
	"./bn": 343,
	"./bn-bd": 342,
	"./bn-bd.js": 342,
	"./bn.js": 343,
	"./bo": 344,
	"./bo.js": 344,
	"./br": 345,
	"./br.js": 345,
	"./bs": 346,
	"./bs.js": 346,
	"./ca": 347,
	"./ca.js": 347,
	"./cs": 348,
	"./cs.js": 348,
	"./cv": 349,
	"./cv.js": 349,
	"./cy": 350,
	"./cy.js": 350,
	"./da": 351,
	"./da.js": 351,
	"./de": 354,
	"./de-at": 352,
	"./de-at.js": 352,
	"./de-ch": 353,
	"./de-ch.js": 353,
	"./de.js": 354,
	"./dv": 355,
	"./dv.js": 355,
	"./el": 356,
	"./el.js": 356,
	"./en-au": 357,
	"./en-au.js": 357,
	"./en-ca": 358,
	"./en-ca.js": 358,
	"./en-gb": 359,
	"./en-gb.js": 359,
	"./en-ie": 360,
	"./en-ie.js": 360,
	"./en-il": 361,
	"./en-il.js": 361,
	"./en-in": 362,
	"./en-in.js": 362,
	"./en-nz": 363,
	"./en-nz.js": 363,
	"./en-sg": 364,
	"./en-sg.js": 364,
	"./eo": 365,
	"./eo.js": 365,
	"./es": 369,
	"./es-do": 366,
	"./es-do.js": 366,
	"./es-mx": 367,
	"./es-mx.js": 367,
	"./es-us": 368,
	"./es-us.js": 368,
	"./es.js": 369,
	"./et": 370,
	"./et.js": 370,
	"./eu": 371,
	"./eu.js": 371,
	"./fa": 372,
	"./fa.js": 372,
	"./fi": 373,
	"./fi.js": 373,
	"./fil": 374,
	"./fil.js": 374,
	"./fo": 375,
	"./fo.js": 375,
	"./fr": 378,
	"./fr-ca": 376,
	"./fr-ca.js": 376,
	"./fr-ch": 377,
	"./fr-ch.js": 377,
	"./fr.js": 378,
	"./fy": 379,
	"./fy.js": 379,
	"./ga": 380,
	"./ga.js": 380,
	"./gd": 381,
	"./gd.js": 381,
	"./gl": 382,
	"./gl.js": 382,
	"./gom-deva": 383,
	"./gom-deva.js": 383,
	"./gom-latn": 384,
	"./gom-latn.js": 384,
	"./gu": 385,
	"./gu.js": 385,
	"./he": 386,
	"./he.js": 386,
	"./hi": 387,
	"./hi.js": 387,
	"./hr": 388,
	"./hr.js": 388,
	"./hu": 389,
	"./hu.js": 389,
	"./hy-am": 390,
	"./hy-am.js": 390,
	"./id": 391,
	"./id.js": 391,
	"./is": 392,
	"./is.js": 392,
	"./it": 394,
	"./it-ch": 393,
	"./it-ch.js": 393,
	"./it.js": 394,
	"./ja": 395,
	"./ja.js": 395,
	"./jv": 396,
	"./jv.js": 396,
	"./ka": 397,
	"./ka.js": 397,
	"./kk": 398,
	"./kk.js": 398,
	"./km": 399,
	"./km.js": 399,
	"./kn": 400,
	"./kn.js": 400,
	"./ko": 401,
	"./ko.js": 401,
	"./ku": 402,
	"./ku.js": 402,
	"./ky": 403,
	"./ky.js": 403,
	"./lb": 404,
	"./lb.js": 404,
	"./lo": 405,
	"./lo.js": 405,
	"./lt": 406,
	"./lt.js": 406,
	"./lv": 407,
	"./lv.js": 407,
	"./me": 408,
	"./me.js": 408,
	"./mi": 409,
	"./mi.js": 409,
	"./mk": 410,
	"./mk.js": 410,
	"./ml": 411,
	"./ml.js": 411,
	"./mn": 412,
	"./mn.js": 412,
	"./mr": 413,
	"./mr.js": 413,
	"./ms": 415,
	"./ms-my": 414,
	"./ms-my.js": 414,
	"./ms.js": 415,
	"./mt": 416,
	"./mt.js": 416,
	"./my": 417,
	"./my.js": 417,
	"./nb": 418,
	"./nb.js": 418,
	"./ne": 419,
	"./ne.js": 419,
	"./nl": 421,
	"./nl-be": 420,
	"./nl-be.js": 420,
	"./nl.js": 421,
	"./nn": 422,
	"./nn.js": 422,
	"./oc-lnc": 423,
	"./oc-lnc.js": 423,
	"./pa-in": 424,
	"./pa-in.js": 424,
	"./pl": 425,
	"./pl.js": 425,
	"./pt": 427,
	"./pt-br": 426,
	"./pt-br.js": 426,
	"./pt.js": 427,
	"./ro": 428,
	"./ro.js": 428,
	"./ru": 429,
	"./ru.js": 429,
	"./sd": 430,
	"./sd.js": 430,
	"./se": 431,
	"./se.js": 431,
	"./si": 432,
	"./si.js": 432,
	"./sk": 433,
	"./sk.js": 433,
	"./sl": 434,
	"./sl.js": 434,
	"./sq": 435,
	"./sq.js": 435,
	"./sr": 437,
	"./sr-cyrl": 436,
	"./sr-cyrl.js": 436,
	"./sr.js": 437,
	"./ss": 438,
	"./ss.js": 438,
	"./sv": 439,
	"./sv.js": 439,
	"./sw": 440,
	"./sw.js": 440,
	"./ta": 441,
	"./ta.js": 441,
	"./te": 442,
	"./te.js": 442,
	"./tet": 443,
	"./tet.js": 443,
	"./tg": 444,
	"./tg.js": 444,
	"./th": 445,
	"./th.js": 445,
	"./tk": 446,
	"./tk.js": 446,
	"./tl-ph": 447,
	"./tl-ph.js": 447,
	"./tlh": 448,
	"./tlh.js": 448,
	"./tr": 449,
	"./tr.js": 449,
	"./tzl": 450,
	"./tzl.js": 450,
	"./tzm": 452,
	"./tzm-latn": 451,
	"./tzm-latn.js": 451,
	"./tzm.js": 452,
	"./ug-cn": 453,
	"./ug-cn.js": 453,
	"./uk": 454,
	"./uk.js": 454,
	"./ur": 455,
	"./ur.js": 455,
	"./uz": 457,
	"./uz-latn": 456,
	"./uz-latn.js": 456,
	"./uz.js": 457,
	"./vi": 458,
	"./vi.js": 458,
	"./x-pseudo": 459,
	"./x-pseudo.js": 459,
	"./yo": 460,
	"./yo.js": 460,
	"./zh-cn": 461,
	"./zh-cn.js": 461,
	"./zh-hk": 462,
	"./zh-hk.js": 462,
	"./zh-mo": 463,
	"./zh-mo.js": 463,
	"./zh-tw": 464,
	"./zh-tw.js": 464
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 886;

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)

var Component = __webpack_require__(484)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(920),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(484)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(919),
  /* scopeId */
  "data-v-1724690d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 919:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "min-height": "800px",
      "position": "relative"
    }
  }, [(_vm.backURL == '') ? _c('div', {
    staticClass: "system"
  }, [_c('div', {
    staticClass: "btnBox"
  }, [_c('div', {
    staticClass: "btn",
    staticStyle: {
      "margin-bottom": "130px"
    },
    on: {
      "click": function($event) {
        return _vm.goSystem(1)
      }
    }
  }, [_vm._v("运营系统")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.goSystem(2)
      }
    }
  }, [_vm._v("报价系统")])])]) : _vm._e(), _vm._v(" "), (_vm.backURL && !_vm.isLogin) ? _c('div', {
    staticClass: "login-bg",
    staticStyle: {
      "position": "relative"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "login-container"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "demo-ruleForm login-form",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginFormRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [(_vm.type == 1) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v("云半径运营管理平台")]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('h3', {
    staticClass: "title"
  }, [_vm._v("旺龙在线报价系统")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 30,
      "placeholder": "账号",
      "autofocus": true
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "maxlength": 16,
      "placeholder": "密码",
      "onpaste": "return false",
      "oncontextmenu": "return false",
      "oncopy": "return false",
      "oncut": "return false"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "verificationCode"
    }
  }, [_c('el-input', {
    staticClass: "codeInput",
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码",
      "maxlength": 4
    },
    model: {
      value: (_vm.loginForm.verificationCode),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "verificationCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.verificationCode"
    }
  }), _vm._v(" "), (_vm.imgFlag) ? _c('img', {
    staticClass: "code",
    attrs: {
      "src": _vm.imgUrl,
      "width": "100",
      "height": "60"
    },
    on: {
      "click": _vm.getVerificationCode
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loginLoading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin($event)
      }
    }
  }, [_vm._v("登录\n                   ")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.yun-r.com/about",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("关于我们")]), _vm._v("  |  "), _c('a', {
    attrs: {
      "href": "https://www.yun-r.com/about/show.php?lang=cn&id=15",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('div', [_vm._v("深圳市旺龙智能科技有限公司")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#a6d0ff",
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n           © 1997-2023 深圳市旺龙智能科技有限公司 All rights reserved.\n           "), _c('a', {
    staticStyle: {
      "color": "#a6d0ff",
      "font-size": "16px"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("粤ICP备18085992号")])])])
}]}

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 924:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 927:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 929:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 930:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 932:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(212);
module.exports = __webpack_require__(487);


/***/ })

},[936]);


// WEBPACK FOOTER //
// static/js/app.7fb1c176b49af6b48015.js